// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__eI6ii","inputWrap":"Table_inputWrap__1VTxz","col":"Table_col__3QgYj","bmiTooltip":"Table_bmiTooltip__1hFkX"};